import React from 'react';
import { usePortal } from '../../contexts/PortalContext';
import { clientStatusLabel, deliverableStage, metaLabel, stageHeading } from '../../utils/deliverables';
import { projectStatus } from '../../utils/status';
import { formatShootDate, isUpcoming } from '../../utils/time';
export function Project() {
  const {
    activeProject
  } = usePortal();
  const nextShootDate = isUpcoming(activeProject.nextShootDate) ? activeProject.nextShootDate : '';
  const rows = [{
    label: 'Client',
    value: activeProject.client
  }, {
    label: 'Project',
    value: activeProject.name
  }, {
    label: 'Type',
    value: activeProject.type
  }, {
    label: 'Status',
    value: projectStatus(activeProject)
  }, {
    label: 'Next Shoot',
    value: nextShootDate ? [formatShootDate(nextShootDate), activeProject.nextShootTime].filter(Boolean).join(' · ') : 'To be confirmed'
  }, {
    label: 'Location',
    value: nextShootDate ? activeProject.location || '—' : '—'
  }, {
    label: 'Portal Producer',
    value: activeProject.producer
  }].filter(row => row.value);
  const visible = activeProject.deliverables.filter(item => item.visibleToClient);
  return <div data-id="element-621" data-mp="3tin4geiakn13">
      <h1 className="font-display text-5xl leading-[0.95] tracking-tight sm:text-7xl" data-id="element-622" data-mp="bap74g32llwp">PROJECT</h1>
      {activeProject.description && <p className="mt-8 max-w-2xl font-display text-xl leading-snug text-charcoal" data-id="element-623" data-mp="780xw7ag2cz7">
          {activeProject.description}
        </p>}

      <div className="mt-16 grid grid-cols-1 gap-14 lg:grid-cols-12 lg:gap-16" data-id="element-624" data-mp="l6iivx8ytbdf">
        <section aria-label="Project details" className="lg:col-span-7" data-id="element-625" data-mp="g9idzpnuqenw">
          <dl className="m-0 border-t border-rule" data-id="element-626" data-mp="uxd6b4xy6h0g">
            {rows.map(row => <div key={row.label} className="flex flex-wrap items-baseline justify-between gap-4 border-b border-rule py-6" data-id="element-627" data-mp="pzbqqtzqcztq">
                <dt className="label m-0 text-mute" data-id="element-628" data-mp="z0jnh7mllslp">{row.label}</dt>
                <dd className="m-0 max-w-md text-right font-display text-2xl leading-tight sm:text-3xl" data-id="element-629" data-mp="yy6ve1n4m1ux">
                  {row.value}
                </dd>
              </div>)}
          </dl>
        </section>

        <section aria-labelledby="deliverables" className="lg:col-span-5 lg:border-l lg:border-rule lg:pl-12" data-id="element-630" data-mp="5njyhqf33dfx">
          <h2 id="deliverables" className="label border-b border-rule pb-4 text-graphite" data-id="element-631" data-mp="afa8twe0u17c">
            Deliverables
          </h2>
          <ul className="m-0 list-none p-0" data-id="element-632" data-mp="fd3coiruqj4g">
            {visible.length === 0 && <li className="py-6 font-display text-lg text-mute" data-id="element-633" data-mp="kav7bkjvsjcc">
                Deliverables are being confirmed.
              </li>}
            {visible.map(item => <li key={item.id} className="border-b border-rule py-6" data-id="element-634" data-mp="tbtfmf1crd0q">
                <p className="font-display text-2xl leading-none" data-id="element-635" data-mp="2r3e82gat2um5">{item.name}</p>
                <p className="label-sm mt-3 text-mute" data-id="element-636" data-mp="2v47sv0sybtat">
                  {metaLabel(item)} · {stageHeading(deliverableStage(item.status))} ·{' '}
                  {clientStatusLabel(item.status)}
                </p>
              </li>)}
          </ul>
        </section>
      </div>
    </div>;
}